import React, { useState, useEffect, useRef } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import Dropdown from "components/Dropdown";
import { useMutation } from "@apollo/client";
import { CREATE_KIOSK } from "graphql/service";
import { Head, Container, InputRow, Footer } from "./styles";
import { debouncedErrorMessage } from "utils/messageUtil";

const ModalAddKiosk = ({
  hidden,
  buttonStyle,
  setKiosks
}) => {

  const inputRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus()
        }
      }, 50)
      return () => clearTimeout(timer)
    }
  }, [isOpen])

  const [username, setUsername] = useState("");
  const [kioskNumber, setKioskNumber] = useState("");
  const [password, setPassword] = useState("");
  const [deviceIds, setDeviceIds] = useState([]);

  const paymentTerminalOptions = [
    { value: "verifone", label: "Verifone" },
    { value: "ingenico", label: "Ingenico" },
    { value: "pax", label: "PAX" },
  ];

  const passportScannerOptions = [
    { value: "fujitsu", label: "Fujitsu" },
    { value: "canon", label: "Canon" },
    { value: "kodak", label: "Kodak" },
  ];

  const keycardDispenserOptions = [
    { value: "safran", label: "Safran" },
    { value: "allegion", label: "Allegion" },
    { value: "assaabloy", label: "Assa Abloy" },
  ];

  const [createKiosk, { loading }] = useMutation(CREATE_KIOSK, {
    onCompleted: (data) => {
      setIsOpen(false);
      setKiosks((prevKiosks) => [...prevKiosks, data.createKiosk]);
      setUsername("");
      setKioskNumber("");
      setPassword("");
      setDeviceIds([]);
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message;
        if (error.message.includes("Validation")) {
          content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception);
        }
        debouncedErrorMessage(content);
      }
    }
  });

  const handleAddKiosk = () => {
    //FIXME: Need to handle multiple devices and their types properly
    createKiosk({
      variables: {
        input: {
          username,
          kioskNumber,
          password,
          deviceIds
        },
      },
    });
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Add New Kiosk"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 169px;
        `}
      >
        <Head>Add Kiosk</Head>
        <Container>
          <InputRow>
            <Input
              inputFieldRef={inputRef}
              title="KIOSK NAME"
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              additionalstyle={`
                width: calc(50% - 8px);
              `}
            />
          </InputRow>
          <InputRow>
            <Input
              title="LOGIN"
              required
              value={kioskNumber}
              onChange={(e) => setKioskNumber(e.target.value)}
              additionalstyle={`
                width: calc(50% - 8px);
              `}
            />
            <Input
              title="PASSWORD"
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              additionalstyle={`
                width: calc(50% - 8px);
              `}
            />
          </InputRow>
          <InputRow>
            <Dropdown
              title="PAYMENT TERMINAL"
              required
              options={paymentTerminalOptions}
              value={paymentTerminalOptions.find((option) => option.value === deviceIds[0])?.label || ""}
              onChange={(e) => {
                const newDeviceIds = [...deviceIds];
                newDeviceIds[0] = e;
                setDeviceIds(newDeviceIds);
              }}
              additionalstyle={`
                width: calc(50% - 8px);
              `}
            />
            <Dropdown
              title="PASSPORT SCANNER"
              required
              options={passportScannerOptions}
              value={passportScannerOptions.find((option) => option.value === deviceIds[1])?.label || ""}
              onChange={(e) => {
                const newDeviceIds = [...deviceIds];
                newDeviceIds[1] = e;
                setDeviceIds(newDeviceIds);
              }}
              additionalstyle={`
                width: calc(50% - 8px);
              `}
            />
          </InputRow>
          <InputRow>
            <Dropdown
              title="KEYCARD DISPENSER"
              required
              options={keycardDispenserOptions}
              value={keycardDispenserOptions.find((option) => option.value === deviceIds[2])?.label || ""}
              onChange={(e) => {
                const newDeviceIds = [...deviceIds];
                newDeviceIds[2] = e;
                setDeviceIds(newDeviceIds);
              }}
              additionalstyle={`
                width: calc(50% - 8px);
              `}
            />
          </InputRow>
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 121px;
            `}
            onClick={handleAddKiosk}
            data-loading={loading}
          >
            {loading ? null : "Add Kiosk"}
          </Button>
        </Footer>
      </MainModal>
    </>
  );
};

export default ModalAddKiosk;
